module.exports = __webpack_public_path__ + "81ddf15b74e4ca0368feb2af4c26058b.jpg";